import React from "react";
import { withFormik, Form, Field } from "formik";
import SelectionFields from "../../../hoc/UI/SelectionFields/SelectionFields";
import * as Yup from "yup";
import Aux from "../../../hoc/Auxilary";
import { Button } from "rsuite";
import { Table, Popover, PopoverBody } from "reactstrap";

const addUINotApplicable = id => {
  const UINotApplicable = document.createElement("option");
  UINotApplicable.innerText = "Not Applicable";
  UINotApplicable.setAttribute("value", "not applicable");
  const targetSelector = document.querySelector(`#${id}`);
  targetSelector.insertBefore(
    UINotApplicable,
    targetSelector.firstElementChild.nextElementSibling
  );
};

class basicInformation extends React.Component {
  state = {
    topoPopoverOpen: false,
    settingPopoverOpen: false
  };
  componentDidMount() {
    addUINotApplicable("second_state_id");
    addUINotApplicable("third_state_id");
  }

  toggle = type => {
    if (type === "topo") {
      this.setState({ topoPopoverOpen: !this.state.topoPopoverOpen });
    } else if (type === "setting") {
      this.setState({ settingPopoverOpen: !this.state.settingPopoverOpen });
    }
  };

  render() {
    const role = localStorage.getItem("project_role");
    let {
      values,
      handleReset,
      errors,
      //             handleChange,
      //             handleBlur,
      touched,
      validateForm,
      //             setErrors,
      //             setStatus,
      setFieldTouched
    } = this.props;
    let buttonGroup;

    const validAndHandle = (func, values) => {
      return () =>
        validateForm().then(errors => {
          if (Object.keys(errors).length !== 0) {
            setFieldTouched("name", true);
            setFieldTouched("project_no", true);
            setFieldTouched("state_id", true);
            setFieldTouched("latitude", true);
            setFieldTouched("longitude", true);
            setFieldTouched("total_capital_cost", true);
            setFieldTouched("concession_length", true);
            setFieldTouched("length", true);
            setFieldTouched("lane_miles", true);
            setFieldTouched("number_of_interchanges", true);
            setFieldTouched("num_bridge_structure", true);
            setFieldTouched("total_bridge_length", true);
            setFieldTouched("num_of_tunnels", true);
            setFieldTouched("total_tunnel_length", true);

            console.log("cannot submit! Validation failed", errors);
          } else {
            if (values.second_state_id === "not applicable") {
              values.second_state_id = null;
            }
            if (values.third_state_id === "not applicable") {
              values.third_state_id = null;
            }
            func(values);
          }
        });
    };
console.log(values);
    if (!values.data_status) {
      buttonGroup = (
        <Aux>
          <Button
            color="blue"
            className="m-2"
            type="button"
            name="submit"
            onClick={validAndHandle(values.submit, values)}
          >
            Submit
          </Button>
          <Button
            color="blue"
            className="m-2"
            type="button"
            name="draft"
            onClick={validAndHandle(values.draft, values)}
          >
            Save as Draft
          </Button>
        </Aux>
      );

      // <Button color="blue" className="m-2" type="Button" name="update" onClick={() => values.update(values)}>Update</Button>
    } else if (values.data_status.name === "Submitted") {
      buttonGroup = (
        <Button
          color="blue"
          className="m-2"
          type="button"
          name="audit"
          onClick={validAndHandle(values.auditBasicInfo, values)}
        >
          Audit
        </Button>
      );
    } else if (values.data_status.name === "Draft") {
      buttonGroup = (
        <Aux>
          <Button
            color="blue"
            type="button"
            name="edit_draft_project"
            onClick={validAndHandle(values.updateDraft, values)}
          >
            Save Updates
          </Button>
          <Button
            color="blue"
            className="ml-2"
            type="button"
            name="edit_draft_project_and_submit"
            onClick={validAndHandle(values.updateDraftAndSubmit, values)}
          >
            Submit for Approval
          </Button>
        </Aux>
      );
    } else if (values.data_status.name === "Published") {
      buttonGroup = (
        <Aux>
          {role === "ROLE_MEMBER" ? (
            <Button
              color="blue"
              className="m-2"
              type="button"
              name="edit_published_project"
              onClick={validAndHandle(values.updatePublished, values)}
            >
              Update
            </Button>
          ) : null}
          {/*TODO: unpublish Button*/}
          {/*<Button color="blue" className="m-2" type="Button" name="unpublished_project" onClick={() => values.unpublish(values)}>Unpublish</Button>*/}
        </Aux>
      );
    }

    return (
      <div className="container-fluid">
        <div>
          {values.data_status ? (
            <h3>Update existing projects</h3>
          ) : (
            <h3>Create a new project</h3>
          )}
          <h3>
            STATUS:{" "}
            {values.data_status ? values.data_status.name : "New Project"}
          </h3>
        </div>

        <Form>
          <fieldset disabled={this.props.disabled}>
            <small className={"d-block"}>
              <span style={{ color: "red" }}>*</span> required
            </small>
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">Basic Information</legend>
              <div className="row">
                {/* <div className={""}> */}

                <label
                  className="col-6 pl-2"
                  htmlFor={"name"}
                  style={errors.name && touched.name && { color: "red" }}
                >
                  Project Name<span style={{ color: "red" }}>*</span>
                  {/*<Field className="form-control-sm form-control" validate={validateEmail} type="text" name={"name"}  value={values["name"] || ''}/>*/}
                  <Field
                    id={"name"}
                    style={
                      errors.name && touched.name && { borderColor: "red" }
                    }
                    className={"form-control-sm form-control"}
                    type="text"
                    name={"name"}
                    value={values["name"] || ""}
                    onKeyPress={() => {}}
                  />
                  {errors.name && touched.name && (
                    <small className={"text-danger"}>{errors.name}</small>
                  )}
                </label>
                {/* </div> */}

                <label className="col-6 pl-2">
                  Alias Name
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"project_alias_name"}
                    value={values["project_alias_name"] || null}
                  />
                </label>
              </div>
              <div className="row">
                <div className="col-4 pl-2">
                  <label>Section No. </label>
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"section_no"}
                    value={values["section_no"] || null}
                  />
                </div>
                <SelectionFields
                  size="col-4 pl-2"
                  id={"proj_status_id"}
                  url={"projectstatus"}
                  showElem={"name"}
                  label={"Project Status"}
                  value={values["proj_status_id"] || "default"}
                />
             

              </div>
              <div className="row">
                <label className="col-10 pl-2">
                  Description
                  <Field
                    component={"textarea"}
                    rows={4}
                    className="form-control-sm form-control"
                    type="text"
                    name={"description"}
                    value={values["description"] || null}
                  />
                </label>
              </div>
            </fieldset>
            {/* <label
              className="col-3 pl-2"
              style={
                errors.total_capital_cost &&
                touched.total_capital_cost && { borderColor: "red" }
              }
            >
              Total Capital Cost
              <Field
                className="form-control-sm form-control"
                type="text"
                name={"total_capital_cost"}
                value={values["total_capital_cost"] || null}
              />
              {errors.total_capital_cost && touched.total_capital_cost && (
                <small className={"text-danger"}>
                  {errors.total_capital_cost}
                </small>
              )}
            </label> */}
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">Characteristics</legend>{" "}
              <SelectionFields
                size="col-4 pl-2"
                id={"proj_type_id"}
                url={"projecttype"}
                showElem={"name"}
                label={"Project Type"}
                value={values["proj_type_id"] || "default"}
              />
              <SelectionFields
                size="col-4 pl-2"
                id={"procurement_model_id"}
                url={"procurementmodel"}
                showElem={"name"}
                label={"Procurement Model"}
                value={values["procurement_model_id"] || "default"}
              />
              <SelectionFields
                size="col-4 pl-2"
                id={"toll_status_id"}
                url={"toll"}
                showElem={"name"}
                label={"Toll Status"}
                value={values["toll_status_id"] || "default"}
              />
            </fieldset>

            {/* <hr />

            <hr /> */}
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">Geography</legend>{" "}
              <div className="row">
                <SelectionFields
                  showError={errors.state_id && touched.state_id}
                  size="col-4 pl-2"
                  id={"state_id"}
                  url={"state"}
                  showElem={"state_name"}
                  label={"State"}
                  value={values["state_id"].split(" ")[0] || "default"}
                  isRequired={false}
                  errorMessage={
                    errors.state_id &&
                    touched.state_id && (
                      <small className={"text-danger"}>{errors.state_id}</small>
                    )
                  }
                />

                <SelectionFields
                  size="col-4 pl-2"
                  id={"second_state_id"}
                  optionValue={"state_id"}
                  url={"state"}
                  showElem={"state_name"}
                  label={"Second State"}
                  value={values["second_state_id"] || "not applicable"}
                  isRequired={false}
                />

                <SelectionFields
                  size="col-4 pl-2"
                  id={"third_state_id"}
                  optionValue={"state_id"}
                  url={"state"}
                  showElem={"state_name"}
                  label={"Third State"}
                  value={values["third_state_id"] || "not applicable"}
                  isRequired={false}
                />
              </div>
              <div className="row mt-1">
                <label className="col-6 pl-2 d-block">
                  Cities
                  <Field
                    component={"textarea"}
                    className="form-control-sm form-control"
                    type="text"
                    name={"cities"}
                    value={values["cities"] || null}
                  />
                </label>

                <label className="col-3 pl-2">
                  Counties
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"counties"}
                    value={values["counties"] || null}
                  />
                </label>
              </div>
              <div className="row">
                <label className="col-3 pl-2">
                  Start Milepost
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"start_milepost"}
                    value={values["start_milepost"] || null}
                  />
                </label>
                <label className="col-3 pl-2">
                  End Milepost
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"end_milepost"}
                    value={values["end_milepost"] || null}
                  />
                </label>

                <label
                  className="col-3 pl-2"
                  style={
                    errors.latitude &&
                    touched.latitude && { borderColor: "red" }
                  }
                >
                  Latitude
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"latitude"}
                    value={values["latitude"] || null}
                  />
                  {errors.latitude && touched.latitude && (
                    <small className={"text-danger"}>{errors.latitude}</small>
                  )}
                </label>
                <label
                  className="col-3 pl-2"
                  style={
                    errors.longitude &&
                    touched.longitude && { borderColor: "red" }
                  }
                >
                  Longitude
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"longitude"}
                    value={values["longitude"] || null}
                  />
                  {errors.longitude && touched.longitude && (
                    <small className={"text-danger"}>{errors.longitude}</small>
                  )}
                </label>
              </div>
              <div className="row ">
                <label className="col-3 pl-2">
                  Setting
                  <sup>
                    <img
                      src={process.env.PUBLIC_URL + "/images/info_icon.png"}
                      height="16"
                      id="setting-info"
                      className={"ml-1"}
                    />
                  </sup>
                  <Popover
                    trigger={"hover"}
                    placement="right"
                    isOpen={this.state.settingPopoverOpen}
                    target="setting-info"
                    toggle={() => this.toggle("setting")}
                  >
                    <PopoverBody>
                      County rurality level is based on 2010 Census county
                      population. Counties with less than 50 percent of the
                      population living in rural areas are classified as{" "}
                      <b>mostly urban</b>; 50 to 99.9 percent are classified as{" "}
                      <b>mostly rural</b>; 100 percent rural are classified as{" "}
                      <b>completely rural</b>.
                    </PopoverBody>
                  </Popover>
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"setting"}
                    value={values["setting"] || null}
                  />
                </label>
              </div>
              <div className="row ">
                <label className="col-6 pl-2 d-block">
                  Topography
                  <sup>
                    <img
                      src={process.env.PUBLIC_URL + "/images/info_icon.png"}
                      height="16"
                      id="topography-info"
                      className={"ml-1"}
                    />
                  </sup>
                  <Popover
                    trigger={"hover"}
                    placement="right"
                    isOpen={this.state.topoPopoverOpen}
                    target="topography-info"
                    toggle={() => this.toggle("topo")}
                  >
                    <PopoverBody>
                      The county's Land Surface Form Topography code is
                      determined via the topography scale from The National
                      Atlas of the United States of America U.S. Department of
                      Interior, U.S. Geological Survey, Washington, DC., 1970.
                      The 21-code scale is separated into 4 groups: Plains
                      (#1-4), Tablelands (#5-8), Open Hills & Mountains
                      (#13-17), and Hills & Mountains (#18-21).
                    </PopoverBody>
                  </Popover>
                  <Field
                    component={"textarea"}
                    className="form-control-sm form-control"
                    type="text"
                    name={"topography"}
                    value={values["topography"] || null}
                  />
                </label>
              </div>
            </fieldset>
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">Features</legend>{" "}
              <div className="row ">
                <label
                  className="col-4 pl-2"
                  style={
                    errors.number_of_lanes &&
                    touched.number_of_lanes && { borderColor: "red" }
                  }
                >
                  Number of Lanes
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"number_of_lanes"}
                    value={values["number_of_lanes"] || null}
                  />
                  {errors.number_of_lanes && touched.number_of_lanes && (
                    <small className={"text-danger"}>
                      {errors.number_of_lanes}
                    </small>
                  )}
                </label>
                <label
                  className="col-4 pl-2"
                  style={
                    errors.length && touched.length && { borderColor: "red" }
                  }
                >
                  Length
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"length"}
                    value={values["length"] || null}
                  />
                  {errors.length && touched.length && (
                    <small className={"text-danger"}>{errors.length}</small>
                  )}
                </label>
                <label
                  className="col-4 pl-2"
                  style={
                    errors.lane_miles &&
                    touched.lane_miles && { borderColor: "red" }
                  }
                >
                  Lane Miles
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"lane_miles"}
                    value={values["lane_miles"] || null}
                  />
                  {errors.lane_miles && touched.lane_miles && (
                    <small className={"text-danger"}>{errors.lane_miles}</small>
                  )}
                </label>
              </div>
              <div className="row ">
                {" "}
                <label
                  className="col-6 pl-2"
                  style={
                    errors.num_bridge_structure &&
                    touched.num_bridge_structure && { borderColor: "red" }
                  }
                >
                  Number of Bridge Structure
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"num_bridge_structure"}
                    value={values["num_bridge_structure"] || null}
                  />
                  {errors.num_bridge_structure &&
                    touched.num_bridge_structure && (
                      <small className={"text-danger"}>
                        {errors.num_bridge_structure}
                      </small>
                    )}
                </label>
                <label
                  className="col-6 pl-2"
                  style={
                    errors.total_bridge_length &&
                    touched.total_bridge_length && { borderColor: "red" }
                  }
                >
                  Total Bridge Length
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"total_bridge_length"}
                    value={values["total_bridge_length"] || null}
                  />
                  {errors.total_bridge_length &&
                    touched.total_bridge_length && (
                      <small className={"text-danger"}>
                        {errors.total_bridge_length}
                      </small>
                    )}
                </label>
              </div>
              <div className="row">
                {" "}
                <label
                  className="col-6 pl-2"
                  style={
                    errors.num_of_tunnels &&
                    touched.num_of_tunnels && { borderColor: "red" }
                  }
                >
                  Number of Tunnels
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"num_of_tunnels"}
                    value={values["num_of_tunnels"] || null}
                  />
                  {errors.num_of_tunnels && touched.num_of_tunnels && (
                    <small className={"text-danger"}>
                      {errors.num_of_tunnels}
                    </small>
                  )}
                </label>
                <label
                  className="col-6 pl-2"
                  style={
                    errors.total_tunnel_length &&
                    touched.total_tunnel_length && { borderColor: "red" }
                  }
                >
                  Total Tunnel Length
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"total_tunnel_length"}
                    value={values["total_tunnel_length"] || null}
                  />
                  {errors.total_tunnel_length &&
                    touched.total_tunnel_length && (
                      <small className={"text-danger"}>
                        {errors.total_tunnel_length}
                      </small>
                    )}
                </label>
              </div>
              <div className="row">
                {" "}
                <label
                  className="col-6 pl-2"
                  style={
                    errors.number_of_interchanges &&
                    touched.number_of_interchanges && { borderColor: "red" }
                  }
                >
                  Number of Interchanges
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"number_of_interchanges"}
                    value={values["number_of_interchanges"] || null}
                  />
                  {errors.number_of_interchanges &&
                    touched.number_of_interchanges && (
                      <small className={"text-danger"}>
                        {errors.number_of_interchanges}
                      </small>
                    )}
                </label>
                <label className="col-6 pl-2">
                  Structure Type
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"structure_type"}
                    value={values["structure_type"] || null}
                  />
                </label>
              </div>
              {/* <label className="col-3 pl-2">
                Concession Term
                <Field
                  className="form-control-sm form-control"
                  type="text"
                  name={"concession_term"}
                  value={values["concession_term"] || ""}
                />
              </label> */}
            </fieldset>
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                Self-Defined Features
              </legend>{" "}
              {/* <label className="col-6 pl-2 d-block"></label> */}
              <div className="col-12 pl-2">
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th style={{ fontWeight: "normal", fontStyle: "italic" }}>
                        {" "}
                        Feature Name{" "}
                      </th>
                      <th style={{ fontWeight: "normal", fontStyle: "italic" }}>
                        {" "}
                        Feature Value{" "}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_name_1"}
                          value={values["feature_name_1"] || null}
                        />
                      </td>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_value_1"}
                          value={values["feature_value_1"] || null}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_name_2"}
                          value={values["feature_name_2"] || null}
                        />
                      </td>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_value_2"}
                          value={values["feature_value_2"] || null}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_name_3"}
                          value={values["feature_name_3"] || null}
                        />
                      </td>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_value_3"}
                          value={values["feature_value_3"] || null}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_name_4"}
                          value={values["feature_name_4"] || null}
                        />
                      </td>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_value_4"}
                          value={values["feature_value_4"] || null}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_name_5"}
                          value={values["feature_name_5"] || null}
                        />
                      </td>
                      <td>
                        <Field
                          className="form-control-sm form-control"
                          type="text"
                          name={"feature_value_5"}
                          value={values["feature_value_5"] || null}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </fieldset>
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">Explanation</legend>
              <Field
                component={"textarea"}
                className="form-control-sm form-control"
                type="text"
                name={"explanation"}
                value={values["explanation"] || null}
              />
              {/* </label> */}
            </fieldset>
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">Notes</legend>
              {/* <label className="col-6 pl-2 d-block"> */}

              <Field
                rows={4}
                component={"textarea"}
                className="form-control-sm form-control"
                type="text"
                name={"notes"}
                value={values["notes"] || null}
              />
              {/* </label> */}
            </fieldset>

            <fieldset className="scheduler-border">
              <legend className="scheduler-border">Links</legend>
              <div className="row">
                <label className="col-6 pl-2 d-block">
                  FAQ
                  <Field
                    component={"textarea"}
                    className="form-control-sm form-control"
                    type="text"
                    name={"faq"}
                    value={values["faq"] || null}
                  />
                </label>
                <label className="col-6 pl-2">
                  Project Website
                  <Field
                    className="form-control-sm form-control"
                    type="text"
                    name={"project_website"}
                    value={values["project_website"] || null}
                  />
                </label>
              </div>
            </fieldset>
          </fieldset>

          {buttonGroup}
          {!values.data_status ||
          (role === "ROLE_MEMBER" && values.data_status.name !== "Submitted") ||
          values.data_status.name === "Draft" ? (
            <Button
              color="red"
              className="ml-2"
              type="button"
              onClick={handleReset}
            >
              Reset
            </Button>
          ) : null}
        </Form>
      </div>
    );
  }
}

var schema = Yup.object().shape({
  name: Yup.string().required(),
//   project_no: Yup.string().required(),
  state_id: Yup.number()
    .notOneOf(["default"])
    .required("state required"),
  latitude: Yup.number()
    .nullable()
    .typeError("Number required"),
  longitude: Yup.number()
    .nullable()
    .typeError("Number required"),
  total_capital_cost: Yup.number()
    .nullable()
    .typeError("Number required"),
  concession_length: Yup.number()
    .nullable()
    .typeError("Number required"),
  length: Yup.number()
    .nullable()
    .typeError("Number required"),
  lane_miles: Yup.number()
    .nullable()
    .typeError("Number required"),
  number_of_interchanges: Yup.number()
    .nullable()
    .typeError("Number required"),
  num_bridge_structure: Yup.number()
    .nullable()
    .typeError("Number required"),
  total_bridge_length: Yup.number()
    .nullable()
    .typeError("Number required"),
  num_of_tunnels: Yup.number()
    .nullable()
    .typeError("Number required"),
  total_tunnel_length: Yup.number()
    .nullable()
    .typeError("Number required")
});

export default withFormik({
  initialValues: {
    firstName: "e",
    lastName: "",
    email: ""
  },
  enableReinitialize: true,
  // validate: validate,

  mapPropsToValues({
    projectItems,
    currentProjectID,
    draft,
    submit,
    updatePublished,
    updateDraft,
    updateDraftAndSubmit,
    unpublish,
    auditBasicInfo
  }) {
    let currentProject = {};
    if (currentProjectID !== null) {
      currentProject = projectItems.filter(
        item => item.project_id === currentProjectID
      )[0];
    }

    return {
      ...currentProject,
      draft,
      submit,
      updatePublished,
      updateDraft,
      updateDraftAndSubmit,
      unpublish,
      auditBasicInfo
    };
  },
  validationSchema: schema
})(basicInformation);
